import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-documents-table',
    templateUrl: './documents-table.component.html',
    styleUrls: ['./documents-table.component.css']
})
export class DocumentsTableComponent implements OnInit {

    @Input() documents: any[] = [];

    constructor() { }

    ngOnInit() {
    }

    onRemoveDocument(document: any) {
        var index = this.documents.indexOf(document);
        if (index > -1) {
            this.documents.splice(index, 1);
        }
    }
}
